export default __webpack_public_path__ + "static/media/Yellow0003.fe625d8f.png";